import React from 'react';
import styled from 'styled-components';

const StyledTD = styled.div`
  background-color: ${(props) => props.backgroundColor ? props.backgroundColor : 'transparent'};
  box-sizing: border-box;
  font-size: ${(props) => props.fontSize}px;
  color: ${(props) => props.fontColor};
  font-style: ${(props) => props.fontStyle};
  font-weight: ${(props) => props.fontWeight};
  text-align: ${(props) => props.textAlign};
  text-transform: ${(props) => props.textTransform};
  text-decoration: ${(props) => props.textDecoration};
  border-top: ${(props) => props.borderTop};
  ${(props) => (props.invalid ? `border-left: ${props.border};` : '')}
  border-right: ${(props) => props.border};
  border-bottom: ${(props) => props.border};
  padding: ${(props) => props.padding}px;
  resize: none;
  ${(props) => (props.textOverflow ? `text-overflow: ${props.textOverflow};` : '')}
  ${(props) => (props.textOverflow === 'ellipsis' ? 'white-space: nowrap;' : '')}
  ${(props) => (props.textOverflow === 'ellipsis' ? 'overflow: hidden;' : '')}
  max-width: ${(props) => (props.width !== undefined ? `${props.width}px` : 'initial')};
  min-width: ${(props) => (props.width !== undefined ? `${props.width}px` : 'initial')};
  ${(props) => (props.cellHeight ? `height: ${props.cellHeight}px;` : '')}
  vertical-align: top;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};

  &:hover, &.focused {
    outline: unset;
    ${(props) => (props.disabled || props.disableHover ? '' : `border: 1px solid ${props.primaryColor}`)};
  }

`;

/**
 * This components main purpose is to isolate the input
 * styles into one location and not require style updates
 * all over the place when we update it in the future.
 */
const TableDataCell = (props) => {
  const { handleCellRef, focused, borderWidth, borderColor, children, disableHover } = props;

  /**
   * We join width and color to a single border style because chrome displays
   * the border as a two tone color if you use border-color and border-width
   * indvidually.
   */
  const border = `${borderWidth}px solid ${borderColor}`;
  // Invalid (required + empty) cells draw the danger colour on all four sides. The top border is
  // otherwise kept transparent so stacked cells don't render a double-thick line.
  const borderTop = props.invalid ? border : `${borderWidth}px solid transparent`;


  return (
    <StyledTD
      className={focused ? 'focused' : ''}
      ref={(e) => { if (handleCellRef && e) handleCellRef(e); }}
      {...props}
      border={border}
      borderTop={borderTop}
      disableHover={disableHover}
    >
      {children}
    </StyledTD>
  );

};

export default React.memo(TableDataCell);
